module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA/ElEQVR42u3WoQrCUBTG8T2GadXgE1ititisPoBNNGj1EQz6AkY1WAXXbLKwatG0oqDMwYQj5wZBFkSwuPMffHDu2e6F++NuzBMRz3JMbx4AAAAAAAAAAAAAAAC0qM7ll/mDCwAAAADgO4DhNHQxC7AMji5mAU5xItHhYgeg1t18XEWfKfQJ6Ix3crtnudnXJHP3TLwC5fZakvTxtnntmfkG+K1Vbrb2zAD0J3uJz6k0B4HUe1tXa88MwGgWSqmxeI211h5/ggAAAAAAABQEIKr4YikAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYB3AagAAAAAAAAAAAAAAAMBonnE2WUjupzf7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Chile.png
// module id = WGg7
// module chunks = 0 62 63